import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { NavigateToPatients } from 'src/app/states/navigations.actions';
import { Store } from '@ngxs/store';

export const loginAuthGuard = (): boolean => {
  const authService: AuthService = inject(AuthService);
  const store: Store = inject(Store);
  const isAuthenticated = authService.isAuthenticated();

  if (isAuthenticated) {
    store.dispatch(new NavigateToPatients());
  }
  return !isAuthenticated;
};
